import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';


const RouteWithLayout = ({ layout: Layout, component: Component, displayName, ...rest  }) => (
      <Route
         {...rest}
                
        render={ props => (<Layout displayName={displayName}> <Component {...props}/> </Layout>) }
    
       
    />
     
);

RouteWithLayout.propTypes = {
  component: PropTypes.any.isRequired,
  layout: PropTypes.any.isRequired,
  path: PropTypes.string
};

export default RouteWithLayout;
